import { makeCall, Methods } from "../../utils/makeCall";
import { GetMemberCountErrors } from "./membersCount.error";

export type GetMemberCountRequest = { link: string };
export type GetMemberCountResponse = { count: number };

export const getMemberCount = makeCall<
  GetMemberCountRequest,
  GetMemberCountResponse,
  GetMemberCountErrors
>(Methods.GetMemberCount);
